import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function MyFilter(props) {
    return (
        <SvgIcon {...props}>
            <path d="M27.7 10.7l-6.4-6.4c-1.1-1.1-3.1-1.1-4.2 0L4.3 17c-.6.6-.9 1.3-.9 2.1s.3 1.6.9 2.1l6.4 6.4c.6.6 1.4.9 2.1.9.8 0 1.5-.3 2.1-.9l12.7-12.7c1.2-1.1 1.2-3 .1-4.2zm-1.4 2.8L13.5 26.2c-.4.4-1 .4-1.4 0l-6.4-6.4c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7l.8-.8 2.9 2.8c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-2.9-2.8 1.6-1.6 5.3 5c.4.4 1 .4 1.4 0s.4-1 0-1.4l-5.2-5 1.7-1.7 3.1 3c.4.4 1 .4 1.4 0s.4-1 0-1.4l-3.1-3 1.6-1.6 5.5 5.2c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-5.4-5.2 1.3-1.3c.2-.2.5-.3.7-.3s.5.1.7.3l6.4 6.4c.3.3.3.9 0 1.3z" />
        </SvgIcon>
    );
}

MyFilter.defaultProps = {
    viewBox: '0 0 32 32'
};

export default MyFilter;
